module.exports = __webpack_public_path__ + "static/img/bang.aea38fab.png";